import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProfileSearch from './ProfileSearch';
import ProfileDetail from './ProfileDetail';

const ProfileSearchContainer = () => {
  const [searchParams] = useSearchParams();
  const memberIdFromUrl =
    searchParams.get('memberId') ||
    searchParams.get('masterProfileId') ||
    searchParams.get('profile') ||
    searchParams.get('q') ||
    '';
  const [selectedProfileId, setSelectedProfileId] = useState(memberIdFromUrl || null);

  useEffect(() => {
    if (memberIdFromUrl) setSelectedProfileId(memberIdFromUrl);
  }, [memberIdFromUrl]);

  const [searchState, setSearchState] = useState({
    searchParams: {
      masterProfileId: '',
      accountId: '',
      memberId: '',
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      gender: '',
      ageFilter: '',
      ageValue: '',
      ageMin: '',
      ageMax: '',
      touchPoint: '',
      riskLevel: '',
      patronType: '',
    },
    searchResults: [],
    uploadedImageBase64: '',
    uploadedImagePreview: '',
    hasSearched: false,
  });

  const handleSelectProfile = (profileId) => {
    setSelectedProfileId(profileId);
  };

  const handleBackToSearch = () => {
    setSelectedProfileId(null);
    if (memberIdFromUrl) {
      window.history.replaceState({}, '', '/profile-safe/search');
    }
  };

  const handleSearchStateChange = (newState) => {
    setSearchState(newState);
  };

  return (
    <div className="h-full">
      {selectedProfileId ? (
        <ProfileDetail
          profileId={selectedProfileId}
          onBack={handleBackToSearch}
        />
      ) : (
        <ProfileSearch
          onSelectProfile={handleSelectProfile}
          searchState={searchState}
          onSearchStateChange={handleSearchStateChange}
        />
      )}
    </div>
  );
};

export default ProfileSearchContainer;